import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postGenerateReportForClientFromSelectedRecords = async (
  projectId,
  recordIds,
  generationParams,
  projectToUseInReport
) => {
  const apiPath = `report/${projectId}/generate-report-for-client-from-records`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { recordIds, generationParams, projectToUseInReport },
    // isLocalApiRequest: true, // Set to true for local development; set to false for production
  });

  const response = await axios(signedRequest);

  return response.data;
};
